// 3rd Party
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

// Components
import {
  selectDataClinicPhotos,
  selectDataClinicSafetyProcedures,
} from '../../connect/selectors';
import ProfileCovidSafetyProcedures from '../ProfileCovidSafetyProcedures/ProfileCovidSafetyProcedures';
import ProfileOfficeDetails from '../ProfileOfficeDetails/ProfileOfficeDetails';
import ProfileOfficeFeatures from '../ProfileOfficeFeatures/ProfileOfficeFeatures';
import ProfileOfficePhotos from '../ProfileOfficePhotos/ProfileOfficePhotos';

// Other

const ProfileOffice = ({ layout }) => {
  const clinicPhotos = useSelector(selectDataClinicPhotos);
  const procedures = useSelector(selectDataClinicSafetyProcedures);

  const hasProcedures = Object.values(procedures).indexOf(true) > -1;

  return (
    <>
      <ProfileOfficeDetails layout={layout} />
      {clinicPhotos.length > 0 && <ProfileOfficePhotos />}
      {hasProcedures 
        && <ProfileCovidSafetyProcedures procedures={procedures} />
      }
      <ProfileOfficeFeatures />
    </>
  );
};

ProfileOffice.propTypes = {
  layout: PropTypes.string,
};

export default ProfileOffice;
